const Joi = require('joi');

export const leaveTypeSchema = Joi.object({
    leave_type_name: Joi.string()
        .trim()
        .min(2)
        .max(50)
        .required()
        .messages({
            'string.base': 'Leave type should be a type of string',
            'string.empty': 'Leave type cannot be an empty field',
            'string.min': 'Leave type should have a minimum length of {#limit}',
            'string.max': 'Leave type should have a maximum length of {#limit}',
            'any.required': 'Leave type is a required field'
        }),
});